// Breakpoint configuration for responsive design
// Following the design system pattern established in the components/design-system/config/ folder

const BREAKPOINT_VALUES = {
    // Width at or below which the navbar switches to its grouped (dropdown) layout.
    NavCollapse: "1086px",
    Medium: "1024px",
    MediumSmall: "900px",
    Small: "799px",
    SuperSmall: "600px",
};

const BREAKPOINTS = {
    NavCollapse: "NavCollapse",
    Medium: "Medium",
    MediumSmall: "MediumSmall",
    Small: "Small",
    SuperSmall: "SuperSmall",
};

// Utility function to create media queries with the defined breakpoints
export const mediaQueries = {
    navCollapse: `@media (max-width: ${BREAKPOINT_VALUES.NavCollapse})`,
    medium: `@media (max-width: ${BREAKPOINT_VALUES.Medium})`,
    mediumSmall: `@media (max-width: ${BREAKPOINT_VALUES.MediumSmall})`,
    small: `@media (max-width: ${BREAKPOINT_VALUES.Small})`,
    superSmall: `@media (max-width: ${BREAKPOINT_VALUES.SuperSmall})`,
};

export { BREAKPOINT_VALUES, BREAKPOINTS };
export default BREAKPOINTS;
